import { createRouter } from '@tanstack/react-router'
import { clearSession, loginHref } from '@/shared/auth'
import type { AppServices } from '@/shared/services'
import { LoadingState } from '@/shared/ui'
import { routeTree } from '../../routeTree.gen'

export function createAppRouter(services: AppServices) {
  const router = createRouter({
    routeTree,
    context: { services },
    defaultPreload: 'intent',
    // Route data comes from TanStack Query; the router should not cache it separately.
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: LoadingState,
    scrollRestoration: true,
  })

  // Session expiry reported by the backend → back to login, preserving the current location.
  services.auth.onExpired(() => {
    clearSession(services.queryClient)
    const current = router.state.location.href
    if (!current.startsWith('/login')) void router.navigate({ href: loginHref(current) })
  })

  return router
}

export type AppRouter = ReturnType<typeof createAppRouter>

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter
  }
}
